// Dark theme color palette
export const darkColors = {
  primary: '#818181ff',
  secondary: '#03dac6',
  background: '#121212',
  surface: '#1e1e1e',
  navbar: '#2d2d2d', // Darker navbar for dark theme
  primaryLight: '#696969ff', // Dark theme equivalent of primary light
  text: {
    primary: '#ffffff',
    secondary: '#aaaaaa',
    disabled: '#666666',
    navbar: '#ffffff',
  },
  accent: '#6366f1',
  error: '#cf6679',
  warning: '#ffb74d',
  info: '#4fc3f7',
  success: '#81c784',
  divider: '#333333',
  // CSS custom properties mapping for dark theme
  cssVariables: {
    '--default-background': '#121212',
    '--secondary-background': '#1e1e1e',
    '--primary-light': '#bb86fc',
    '--primary-text': '#ffffff',
    '--secondary-text': '#aaaaaa',
    '--drawer-width': '240px',
    '--default-radius': '0.3rem',
  },
} as const;
